import { render, staticRenderFns } from "./ManagePromotionInvitations.vue?vue&type=template&id=63740ce4"
import script from "./ManagePromotionInvitations.vue?vue&type=script&lang=js"
export * from "./ManagePromotionInvitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports